import styled, { createGlobalStyle } from 'styled-components';

/** Same as `@ecargo/web-components` `ECARGO_LAYOUT_BREAKPOINTS.minLg` (fixed rail vs overlay). */
const ECARGO_MIN_LG_PX = 1080;

/**
 * eCargo Sidebar uses 240px (lg), 288px (md), or 330px (xl) when expanded. We keep a fixed
 * 240px open rail so the layout matches the previous Hangar shell. Collapsed (4.5rem) is
 * unchanged: overrides only apply when the inner wrapper is not `aria-hidden` (expanded).
 */
export const EcargoSidebarExpandedWidth240 = createGlobalStyle`
  @media (min-width: ${ECARGO_MIN_LG_PX}px) {
    [role='complementary'][aria-label='Navegación lateral']:has(
        [data-testid='sidebar-wrapper'][aria-hidden='false']
      ) {
      width: 240px !important;
      max-width: 240px !important;
      min-width: 240px !important;
      box-sizing: border-box;
    }

    [role='complementary'][aria-label='Navegación lateral']:has(
        [data-testid='sidebar-wrapper'][aria-hidden='false']
      )
      + div {
      margin-left: 240px !important;
    }
  }
`;

/**
 * Main content region.
 * - `$embedded`: inside eCargo `Sidebar`’s content column (margin-left is handled by the
 *   package). Must not use `position: fixed` full-bleed or it covers the fixed rail and
 *   paints above the sidebar.
 * - standalone: login / unsubscribe / feedback (no shell) — full-viewport scroll.
 */
export const LayoutContainer = styled.div<{ $embedded: boolean; $noPadding?: boolean }>`
  background-color: ${(props) => props.theme.tokens.color.background.secondary};
  transition: none;
  padding: 0;
  box-sizing: border-box;

  ${(props) =>
    props.$embedded
      ? `
    position: relative;
    width: 100%;
    min-width: 0;
    flex: 1 1 auto;
    min-height: 100%;
  `
      : `
    position: fixed;
    inset: 0;
    overflow-y: auto;
  `}

  @media (min-width: 1336px) {
    padding: ${(props) => (props.$noPadding ? 0 : '24px')};
  }

  @media (min-width: 1920px) {
    padding: ${(props) => (props.$noPadding ? 0 : '40px')};
  }
`;
